
            const data = {"name":"scrumHaltSprint","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<circle pid=\"0\" cx=\"12\" cy=\"12\" r=\"6\" transform=\"rotate(90 12 12)\" _fill=\"#43A047\"/>","originalColors":[{"type":"fill","color":"#43A047"}],"stopColors":[]}}
        
                    module.exports = data
                    